import {
	GENERAL_SEARCH_TAGS_REQUEST,
	GENERAL_SEARCH_TAGS_RESULT,
	GENERAL_SEARCH_MANUFACTURERS_REQUEST,
	GENERAL_SEARCH_MANUFACTURERS_RESULT,
	GENERAL_SEARCH_SIM_PROVIDER_ACCOUNTS_REQUEST,
	GENERAL_SEARCH_SIM_PROVIDER_ACCOUNTS_RESULT,
	GENERAL_SEARCH_SIM_PROVIDERS_REQUEST,
	GENERAL_SEARCH_SIM_PROVIDERS_RESULT,
	GENERAL_SEARCH_DEVICE_MODELS_REQUEST,
	GENERAL_SEARCH_DEVICE_MODELS_RESULT,
	GENERAL_SEARCH_ENTITY_REQUEST,
	GENERAL_SEARCH_ENTITY_RESULT,
	GENERAL_SEARCH_DEALERS_REQUEST,
	GENERAL_SEARCH_DEALERS_RESULT,
	GENERAL_SEARCH_TIMEZONES_REQUEST,
	GENERAL_SEARCH_TIMEZONES_RESULT,
	GENERAL_SAVE_AUDIT_LOG,
	GENERAL_SAVE_AUDIT_LOG_RESULT,
	GENERAL_GENERIC_EXPORT_SEND,
	GENERAL_GENERIC_EXPORT_SEND_RESULT,
	GENERAL_COUNT_PEDING_NOTIFICATIONS,
	GENERAL_COUNT_PEDING_NOTIFICATIONS_RESULT,
	GENERAL_SEARCH_NOTIFICATIONS,
	GENERAL_SEARCH_NOTIFICATIONS_RESULT,
	GENERAL_UPDATE_NOTIFICATION,
	GENERAL_UPDATE_NOTIFICATION_RESULT,
	GENERAL_SAVE_PREFERENCE,
	GENERAL_GET_PREFERENCE,
	GENERAL_EXPORT,
	GENERAL_SET_TOTAL_RECORDS,
	GENERAL_SET_CREATE_NOTIFICATION_ID,
	GENERAL_CATALOG_INITIAL,
	GENERAL_CATALOG_INITIAL_RESULT,
	GENERAL_DOWNLOAD_REPORT_FILE_REQUEST,
	GENERAL_DOWNLOAD_REPORT_FILE_RESULT,
	GENERAL_EXPORT_PENDING_ADD,
	GENERAL_EXPORT_PENDING_COMPLETE,
	GENERAL_EXPORT_PENDING_REMOVE,
} from "Redux/actionTypes";

export const setCreateNotificationId = (data) => ({
	type: GENERAL_SET_CREATE_NOTIFICATION_ID,
	payload: data,
});

export const searchTagsRequest = (data) => ({
	type: GENERAL_SEARCH_TAGS_REQUEST,
	payload: data,
});

export const searchTagsResult = (data) => ({
	type: GENERAL_SEARCH_TAGS_RESULT,
	payload: data,
});

export const searchManufacturersRequest = (data) => ({
	type: GENERAL_SEARCH_MANUFACTURERS_REQUEST,
	payload: data,
});

export const searchManufacturersResult = (data) => ({
	type: GENERAL_SEARCH_MANUFACTURERS_RESULT,
	payload: data,
});

export const searchSimProviderAccountsRequest = (data) => ({
	type: GENERAL_SEARCH_SIM_PROVIDER_ACCOUNTS_REQUEST,
	payload: data,
});

export const searchSimProviderAccountsResult = (data) => ({
	type: GENERAL_SEARCH_SIM_PROVIDER_ACCOUNTS_RESULT,
	payload: data,
});

export const searchSimProvidersRequest = (data) => ({
	type: GENERAL_SEARCH_SIM_PROVIDERS_REQUEST,
	payload: data,
});

export const searchSimProvidersResult = (data) => ({
	type: GENERAL_SEARCH_SIM_PROVIDERS_RESULT,
	payload: data,
});

export const searchDeviceModelsRequest = (data) => ({
	type: GENERAL_SEARCH_DEVICE_MODELS_REQUEST,
	payload: data,
});

export const searchDeviceModelsResult = (data) => ({
	type: GENERAL_SEARCH_DEVICE_MODELS_RESULT,
	payload: data,
});

export const searchEntityRequest = (dataEntry) => ({
	type: GENERAL_SEARCH_ENTITY_REQUEST,
	payload: dataEntry,
});


export const searchEntityResult = (data) => ({
	type: GENERAL_SEARCH_ENTITY_RESULT,
	payload: data,
});

export const searchDealersRequest = (data) => ({
	type: GENERAL_SEARCH_DEALERS_REQUEST,
	payload: data,
});

export const searchDealersResult = (data) => ({
	type: GENERAL_SEARCH_DEALERS_RESULT,
	payload: data,
});

export const searchTimeZonesRequest = (data) => ({
	type: GENERAL_SEARCH_TIMEZONES_REQUEST,
	payload: data,
});

export const searchTimeZonesResult = (data) => ({
	type: GENERAL_SEARCH_TIMEZONES_RESULT,
	payload: data,
});

//entityName, entityId, action, oldValues, newValues, updatedBy, updatedOn
export const saveAuditLog = (data) => ({
	type: GENERAL_SAVE_AUDIT_LOG,
	payload: data,
});

export const saveAuditLogResult = (data) => ({
	type: GENERAL_SAVE_AUDIT_LOG_RESULT,
	payload: data,
});

export const genericExportSend = (type, graphqlQuery, graphqlVariables, columns, exportFormat, isPXSource, isDynamo, pxAccount, name, custom, limit) => ({
	type: GENERAL_GENERIC_EXPORT_SEND,
	payload: { type, graphqlQuery, graphqlVariables, columns, exportFormat, isPXSource, isDynamo, pxAccount, name, custom, limit },
});

export const genericExportResult = (data) => ({
	type: GENERAL_GENERIC_EXPORT_SEND_RESULT,
	payload: data,
});

export const searchCountNotificationsRequest = (data) => ({
	type: GENERAL_COUNT_PEDING_NOTIFICATIONS,
	payload: data,
});

export const searchCountNotificationsRequestResult = (data) => ({
	type: GENERAL_COUNT_PEDING_NOTIFICATIONS_RESULT,
	payload: data,
});

export const searchNotificationsRequest = (limit, nextToken) => ({
	type: GENERAL_SEARCH_NOTIFICATIONS,
	payload: { limit, nextToken },
});

export const searchNotificationsRequestResult = (data) => ({
	type: GENERAL_SEARCH_NOTIFICATIONS_RESULT,
	payload: data,
});

export const updateNotificationRequest = (id) => ({
	type: GENERAL_UPDATE_NOTIFICATION,
	payload: { id },
});

export const updateNotificationRequestResult = (data) => ({
	type: GENERAL_UPDATE_NOTIFICATION_RESULT,
	payload: data,
});

export const generalSavePreference = (data) => ({
	type: GENERAL_SAVE_PREFERENCE,
	payload: data,
});

export const generalGetPreference = (data) => ({
	type: GENERAL_GET_PREFERENCE,
	payload: data,
});

export const generalExport = (data) => ({
	type: GENERAL_EXPORT,
	payload: data,
});

export const generalSetTotalRecords = (data) => ({
	type: GENERAL_SET_TOTAL_RECORDS,
	payload: data,
});

export const generalCatalogInitial = () => ({
	type: GENERAL_CATALOG_INITIAL,
	//payload: { keys, filters },
});

export const generalCatalogInitialResult = (data) => ({
	type: GENERAL_CATALOG_INITIAL_RESULT,
	payload: data,
});

export const downloadReportFileRequest = (data) => ({
	type: GENERAL_DOWNLOAD_REPORT_FILE_REQUEST,
	payload: data,
});

export const downloadReportFileResult = (data) => ({
	type: GENERAL_DOWNLOAD_REPORT_FILE_RESULT,
	payload: data,
});

export const addPendingExport = (data) => ({
	type: GENERAL_EXPORT_PENDING_ADD,
	payload: data,
});

export const completePendingExport = (data) => ({
	type: GENERAL_EXPORT_PENDING_COMPLETE,
	payload: data,
});

export const removePendingExport = (id) => ({
	type: GENERAL_EXPORT_PENDING_REMOVE,
	payload: id,
});